<template>
    <div>

        <Rooms v-if="step == steps.rooms" :department="department" :rooms="rooms" :progress="progress" :basket="basket"
            :basketSummary="basketSummary" :padlockPrice="padlockPrice" :invitationCode="invitationCode" :step="step"
            :steps="steps" :nextStep="steps.customer" :parentLink="parentLink" :nearestDepartments="nearestDepartments"
            :waitingListLink="waitingListLink" :supportLink="supportLink" :findOtherLink="findOtherLink"
            :hasRooms="hasRooms" :queryKeys="queryKeys" :totalPriceForMonth="totalPriceForMonth"
            :totalPriceForPayment="totalPriceForPayment" @stepChange="stepChange" @roomChanged="handleRoomChange"
            @addRoom="handleAddRoom" @removeRoom="handleRemoveRoom" @invitationCodeChange="handleInvitationCodeChange"
            @addDiscountCode="handleAddDiscountCode" @removeDiscountCode="handleRemoveDiscountCode"
            @togglePadlock="calculateBasketPrice(true)" @toggleSpinner="toggleSpinner" />
        <Customer v-if="step == steps.customer" :department="department" :existingUserObject="customerInfo"
            :progress="progress" :basket="basket" :basketSummary="basketSummary" :padlockPrice="padlockPrice"
            :invitationCode="invitationCode" :step="step" :steps="steps" :nextStep="steps.confirm" :referrer="referrer"
            :mitIDStatus="mitIDStatus" :mitIDStatuses="mitIDStatuses" :isNewCustomer="isNewCustomer"
            :customerHasHiddenInfo="customerHasHiddenInfo" :customerMissesAddress="customerMissesAddress"
            @stepChange="stepChange" @roomChanged="handleRoomChange" @addRoom="handleAddRoom"
            @removeRoom="handleRemoveRoom" @invitationCodeChange="handleInvitationCodeChange"
            @addDiscountCode="handleAddDiscountCode" @removeDiscountCode="handleRemoveDiscountCode"
            @togglePadlock="calculateBasketPrice(true)" @toggleSpinner="toggleSpinner"
            @customerInfoUpdated="handleCustomerInfoUpdate" @saveState="saveState" @initMitID="handleMitIDInit"
            @setMitIDStatus="getMitIDStatus" @verifyMitID="verifyMitID" />
        <Confirm v-if="step == steps.confirm" :queryKeys="queryKeys" :department="department" :progress="progress"
            :basket="basket" :basketSummary="basketSummary" :padlockPrice="padlockPrice"
            :invitationCode="invitationCode" :step="step" :steps="steps" :nextStep="steps.end" :referrer="referrer"
            :mitIDCodeTimestamp="mitIDCodeTimestamp" :hasSeenNoAvailableRoomsMessage="hasSeenNoAvailableRoomsMessage"
            @stepChange="stepChange" @roomChanged="handleRoomChange" @addRoom="handleAddRoom"
            @removeRoom="handleRemoveRoom" @invitationCodeChange="handleInvitationCodeChange"
            @addDiscountCode="handleAddDiscountCode" @removeDiscountCode="handleRemoveDiscountCode"
            @togglePadlock="calculateBasketPrice(true)" @toggleSpinner="toggleSpinner" :customerInfo="customerInfo"
            :isNewCustomer="isNewCustomer" @customerInfoUpdated="handleCustomerInfoUpdate" @saveState="saveState"
            @initMitID="handleMitIDInit" @setMitIDStatus="getMitIDStatus" @verifyMitID="verifyMitID" />
        <End v-if="step == steps.end"></End>
        <DynamicDialog />
        <ConfirmDialog :breakpoints="{ '960px': '85vw', '640px': '100vw' }" :style="{ maxWidth: 'min(85%,1500px)' }">
            <template #message="slotProps">
                <div v-html="slotProps.message.message">
                </div>
            </template>
        </ConfirmDialog>
        <Toast />
    </div>
</template>
<script>
import bookingSteps from './booking/bookingSteps.js';
import bookingQueryKeys from './booking/bookingQueryKeys.js';
import bfdl from './../bookingFlowDataLayer.js';
import DynamicDialog from 'primevue/dynamicdialog';
import Toast from 'primevue/toast';
import PadlockPrompt from './components/padlockPrompt.vue';
import Rooms from './booking/rooms.vue';
import Customer from './booking/customer.vue';
import Confirm from './booking/confirm.vue';
import ConfirmDialog from 'primevue/confirmdialog';
import End from './booking/end.vue';
import MitID from './../mitId.js';
import VueHelpers from './vueHelpers.js';
import { nextTick } from 'vue';

export default {
    name: "roomBooking",
    components: {
        DynamicDialog,
        PadlockPrompt,
        Rooms,
        Customer,
        Confirm,
        Toast,
        ConfirmDialog,
        End
    },
    data() {
        return {
            dictionary: [],
            basket: [],
            basketSummary: null,
            totalPriceForMonth: 0,
            totalPriceForPayment: 0,
            invitationCode: null,
            invitationCodeTimeStamp: Math.round(Date.now() / 1000),
            progress: 25,
            padlockPrice: 100,
            step: null,
            steps: null,
            customerInfo: null,
            isNewCustomer: false,
            customerHasHiddenInfo: false,
            customerMissesAddress: false,
            queryKeys: null,
            mitIDQueryKeys: null,
            hasRooms: false,
            department: null,
            nearestDepartments: null,
            parentLink: null,
            waitingListLink: null,
            supportLink: null,
            findOtherLink: null,
            referrer: null,
            rooms: null,
            nodeId: null,
            mitIDStatus: -1,
            mitIDStatuses: {},
            mitIDCodeTimestamp: null,
            hasSeenNoAvailableRoomsMessage: false,
        };
    },
    created() {
        const vm = this;
        vm.toggleSpinner(true);
        vm.nodeId = parseInt(vm.$parent.nodeId);
        vm.referrer = document.referrer;
        vm.mitIDStatuses = MitID.statuses;

        vm.department = JSON.parse(vm.$parent.department);
        vm.rooms = JSON.parse(vm.$parent.rooms);
        vm.parentLink = vm.$parent.parentLink;
        vm.nearestDepartments = JSON.parse(vm.$parent.nearestDepartments);
        vm.waitingListLink = vm.$parent.waitingListLink;
        vm.supportLink = vm.$parent.supportLink;
        vm.findOtherLink = vm.$parent.findOtherLink;
        vm.steps = bookingSteps;
        vm.queryKeys = bookingQueryKeys;
        vm.mitIDQueryKeys = MitID.queryKeys;

        const savedState = JSON.parse(sessionStorage.getItem(`booking${vm.nodeId}`));
        if (savedState) {
            vm.dictionary = savedState.dictionary;
            vm.basket = savedState.basket;
            vm.invitationCode = savedState.invitationCode;
            vm.invitationCodeTimeStamp = savedState.invitationCodeTimeStamp;
            vm.progress = savedState.progress;
            vm.step = savedState.step;
            vm.customerInfo = savedState.customerInfo;
            vm.isNewCustomer = savedState.isNewCustomer;
            vm.customerHasHiddenInfo = savedState.customerHasHiddenInfo;
            vm.customerMissesAddress = savedState.customerMissesAddress;
            vm.hasRoms = savedState.hasRooms;
            vm.padlockPrice = savedState.padlockPrice;
            vm.mitIDStatus = savedState.mitIDStatus;
            vm.mitIDCodeTimestamp = savedState.mitIDCodeTimestamp;
            vm.hasSeenNoAvailableRoomsMessage = savedState.hasSeenNoAvailableRoomsMessage;
        } else {
            vm.referrer = document.referrer;
            if (!vm.referrer.includes('bambora.com') && !vm.referrer.includes('criipto')) {
                bfdl.pushToDataLayer(bfdl.getEventName(vm.referrer), bfdl.steps.begin);
            }

            fetch("/umbraco/api/dictionaryapi/GetRoomBookingDictionary").then((response) => response.json())
                .then((data) => {
                    vm.dictionary = data;
                })
                .catch((error) => {
                    console.log(error);
                });

            vm.department = JSON.parse(vm.$parent.department);
            vm.rooms = JSON.parse(vm.$parent.rooms);
            vm.parentLink = vm.$parent.parentLink;
            vm.waitingListLink = vm.$parent.waitingListLink;
            vm.supportLink = vm.$parent.supportLink;
            vm.findOtherLink = vm.$parent.findOtherLink;
            vm.steps = bookingSteps;
            vm.queryKeys = bookingQueryKeys;

            fetch(`/umbraco/api/departmentsapi/GetDepartmentRoomsCount?departmentId=${vm.department.Id}`)
                .then(response => response.text()).then(data => {
                    vm.hasRooms = parseInt(data) > 0;
                })
                .catch((error) => {
                    console.log(error);
                });

            fetch("/umbraco/api/externalResourceApi/GetSettings")
                .then(response => response.json())
                .then(data => {
                    vm.padlockPrice = data.PadlockPriceInKronerWithVat;
                })
                .catch(error => {
                    console.log(error);
                });

            if ('URLSearchParams' in window) {
                var searchParams = new URLSearchParams(window.location.search);
                const stepFromQuery = searchParams.get(vm.queryKeys.step);
                if (stepFromQuery != null && (stepFromQuery == vm.steps.end || stepFromQuery == vm.steps.customer)) {
                    vm.step = stepFromQuery;
                } else {
                    vm.updateQueryString(vm.queryKeys.step, null, true);
                    vm.step = vm.steps.rooms;
                    const roomsFromQuery = searchParams.get(vm.queryKeys.rooms);
                    if (roomsFromQuery != null) {

                        const roomsArray = roomsFromQuery.split(',')
                        //TODO: Make this synced and then first calculate price when it's done!
                        roomsArray.forEach(roomNumber => {
                            vm.toggleSpinner(true);
                            fetch(`/umbraco/api/departmentsApi/GetRoomByNumber?number=${roomNumber}&departmentId=${vm.department.Id}&getAllInSize=True`)
                                .then(response => response.json())
                                .then(data => {
                                    if (data) {
                                        const basketEntry = {
                                            padlock: false,
                                            discountCode: null,
                                            room: data.find(x => x.Number == roomNumber),
                                            otherRooms: data.filter(x => x.Number != roomNumber)
                                        }
                                        vm.basket.push(basketEntry);
                                        vm.calculateBasketPrice(true);
                                    }
                                    vm.toggleSpinner(false);

                                })
                                .catch(error => {
                                    console.log(error);
                                    vm.toggleSpinner(false);
                                });
                        });
                    }

                    if (searchParams.has(vm.queryKeys.fromRecommendation)) {
                        vm.hasSeenNoAvailableRoomsMessage = true;
                        vm.updateQueryString(vm.queryKeys.fromRecommendation, null, true);
                    }
                }
            } else {
                vm.step = vm.steps.rooms;
            }
        }

        vm.toggleSpinner(false);
    },
    methods: {
        saveState: function () {
            sessionStorage.setItem(this.sessionStorageKey, JSON.stringify({
                dictionary: this.dictionary,
                basket: this.basket,
                invitationCode: this.invitationCode,
                invitationCodeTimeStamp: this.invitationCodeTimeStamp,
                mitIDCodeTimestamp: this.mitIDCodeTimestamp,
                progress: this.progress,
                step: this.step,
                customerInfo: this.customerInfo,
                isNewCustomer: this.isNewCustomer,
                customerHasHiddenInfo: this.customerHasHiddenInfo,
                customerMissesAddress: this.customerMissesAddress,
                hasRooms: this.hasRooms,
                padlockPrice: this.padlockPrice,
                mitIDStatus: this.mitIDStatus,
                hasSeenNoAvailableRoomsMessage: this.hasSeenNoAvailableRoomsMessage

            }));
        },
        clearState: function () {
            sessionStorage.removeItem(this.sessionStorageKey);
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
        updateQueryString: function (name, value, remove = false) {
            if ('URLSearchParams' in window) {
                var searchParams = new URLSearchParams(window.location.search);
                if (!remove) {
                    searchParams.set(name, value);

                } else {
                    searchParams.delete(name);
                }
                const updatedUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
                window.history.pushState({ path: updatedUrl }, '', updatedUrl);
            }
        },
        stepChange(newStep, subtractProgress = false) {
            if (newStep != null && typeof newStep != 'undefined') {
                if (subtractProgress) {
                    this.progress -= 25;
                } else {
                    this.progress += 25;
                }
                this.step = newStep;

                this.updateQueryString(this.queryKeys.step, this.step);
                this.scrollToTopOfComponent();
            }
        },
        handleCustomerInfoUpdate(data) {
            this.customerInfo = data.customer;
            if (data.isNewCustomer != null) {
                this.isNewCustomer = data.isNewCustomer;
            }
        },
        handleRoomChange(roomId) {
            const vm = this;
            // var basketEntry = vm.basket.find(x => x.room.Id == roomId);
            vm.calculateBasketPrice(true);
        },
        handleAddRoom(rooms) {
            const vm = this;
            let roomToAdd = null;

            //If we have a single room, cast it to an array
            if (!rooms.length) {
                rooms = [rooms];
            }

            //Let's find the first room that is not already in our basket
            rooms.every(room => {
                if (!vm.basket.some(x => x.room.Id == room.Id)) {
                    roomToAdd = room;
                    return false;
                }
                return true;
            });

            //If we did not find any, the user is already trying to book all the rooms
            if (roomToAdd == null) {
                vm.$toast.add({
                    severity: 'error', closable: false, summary: vm.dictionary.BookingFlowRoomsDuplicateRoomErrorTitle, detail: vm.dictionary.BookingFlowRoomsDuplicateRoomErrorText, life: 10000
                })
            } else {
                vm.$dialog.open(PadlockPrompt, {
                    props: {
                        showHeader: false,
                        modal: true,
                        baseZIndex: 100,
                        closeOnEscape: true,
                        closable: true,
                        dismissableMask: true,
                        draggable: false
                    },
                    data: {
                        roomId: roomToAdd.Id,
                        padlockPrice: vm.padlockPrice
                    },
                    onClose: (options) => {
                        const data = options.data;
                        if (data) {
                            const basketEntry = {
                                padlock: data.acceptPadlock,
                                discountCode: null,
                                room: Object.assign({}, roomToAdd),
                                otherRooms: rooms
                            }
                            vm.basket.push(basketEntry);
                            vm.calculateBasketPrice(true);
                        }
                    }
                })
            }
        },
        handleRemoveRoom(roomSize) {
            const vm = this;
            const basketIndex = vm.basket.findIndex(x => x.room.Size == roomSize);
            vm.basket.splice(basketIndex, 1);
            vm.calculateBasketPrice(true);
        },
        handleInvitationCodeChange(invitationCode, remove) {
            const vm = this;
            if (remove) {
                this.invitationCode = null;
                vm.$toast.add({
                    severity: 'info', summary: vm.dictionary.BookingFlowInvitationCodeRemoveNotificationTitle, detail: vm.dictionary.BookingFlowInvitationCodeRemoveNotificationText, life: 10000
                })
            } else if (invitationCode != '') {
                this.invitationCode = invitationCode;
                vm.$toast.add({
                    severity: 'success', summary: vm.dictionary.BookingFlowInvitationCodeAddNotificationTitle, detail: vm.dictionary.BookingFlowInvitationCodeAddNotificationText, life: 10000
                })
            }
        },
        handleAddDiscountCode(discountCode, roomId) {
            const vm = this;
            if (VueHelpers.getTimeDifferenceInSeconds(vm.invitationCodeTimeStamp) < 5) {
                vm.$toast.add({
                    severity: 'warn', summary: vm.dictionary.BookingFlowDiscountExcessiveErrorTitle, detail: vm.dictionary.BookingFlowDiscountExcessiveErrorText, life: 10000
                });
            } else {
                vm.invitationCodeTimeStamp = Math.round(Date.now() / 1000);
                vm.basket.find(x => x.room.Id == roomId).discountCode = discountCode;
                vm.calculateBasketPrice(true);
            }
        },
        calculateBasketPrice(triggerSpinner = false, callback = null) {
            const vm = this;
            if (triggerSpinner) {
                vm.toggleSpinner(true);
            }


            const requestObjects = vm.basket.map(x => { return { withPadlock: x.padlock, couponCode: x.discountCode, roomId: x.room.Id } });
            if (requestObjects.length > 0) {
                const encodedObject = encodeURIComponent(JSON.stringify(requestObjects));

                fetch(`/umbraco/api/departmentsApi/GetBasketPrice?basketEntries=${encodedObject}`)
                    .then(response => response.json())
                    .then(data => {
                        if (data) {
                            console.log(data);
                            vm.totalPriceForMonth = data.TotalPriceForMonth;
                            vm.totalPriceForPayment = data.TotalPriceForPayment;
                            vm.basketSummary = data.Summary;

                            vm.basket.forEach(basketEntry => {
                                const calculatedBasketEntry = data.Rooms.find(x => x.RoomId == basketEntry.room.Id);

                                //If the basketEntry has a discount code, but it's not in the calculation, it's invalid, and we remove it from the basketEntry
                                if (basketEntry.discountCode != null && !calculatedBasketEntry.Lines.some(x => x.DiscountCode == basketEntry.discountCode)) {
                                    basketEntry.discountCode = null;
                                    vm.$toast.add({
                                        severity: 'error', closable: false, summary: vm.dictionary.BookingFlowDiscountInvalidCodeErrorTitle, detail: vm.dictionary.BookingFlowDiscountInvalidCodeErrorText, life: 10000
                                    });
                                }
                                basketEntry["priceCalculation"] = calculatedBasketEntry;

                            });
                        }
                        vm.toggleSpinner(false);

                    })
                    .catch(error => {
                        console.log(error);
                        vm.toggleSpinner(false);
                    });
            } else {
                vm.toggleSpinner(false);

                vm.basketSummary = null;
            }
        },
        handleRemoveDiscountCode(roomId) {
            const vm = this;
            vm.basket.find(x => x.room.Id == roomId).discountCode = null;

            this.calculateBasketPrice(true, function () {
                vm.$toast.add({
                    severity: 'info', summary: vm.dictionary.BookingFlowDiscountRemoveCodeNotificationTitle, detail: vm.dictionary.BookingFlowDiscountRemoveCodeNotificationText, life: 10000
                });
            })
        },
        scrollToTopOfComponent() {
            setTimeout(() => {
                const isSmallScreen = window.matchMedia('(max-width: 768px)');
                let componentTop = document.querySelector('.booking').offsetTop;
                if (isSmallScreen.matches) {
                    componentTop -= 80;
                } else {
                    componentTop -= 249;
                }

                window.scrollTo({
                    top: componentTop,
                    behavior: 'smooth',
                });
            }, 150);

        },
        async getMitIDStatus(override) {
            if (override !== null && override !== undefined) {
                this.mitIDStatus = override;
            } else {
                this.mitIDStatus = await MitID.getCurrentUserStatus();
            }
        },
        async handleMitIDInit(data) {
            this.saveState();
            const callbackUrl = this.getMitIDCallbackUrl(data.step, data.additionalQuery ?? '');
            const authUri = await MitID.GetAuthUri(callbackUrl, true);
            console.log(authUri);
            if (authUri != "") {
                window.location.replace(authUri);
            } else {
                vm.$toast.add({
                    severity: 'error', closable: false, summary: vm.dictionary.BookingFlowMitIdGeneralErrorTitle, detail: vm.dictionary.BookingFlowMitIdAuthInitErrorText, life: 10000
                })
            }
        },
        async verifyMitID(data) {
            const vm = this;
            vm.toggleSpinner(true);
            vm.clearState();

            const queryParameters = new URLSearchParams(window.location.search);
            const code = queryParameters.get(vm.mitIDQueryKeys.code);
            const state = queryParameters.get(vm.mitIDQueryKeys.state);
            const callbackUrl = vm.getMitIDCallbackUrl(data.step, data.additionalQuery ?? '');

            //Remove MitID query keys so we dont keep triggering af verification
            this.updateQueryString(this.mitIDQueryKeys.code, null, true);
            this.updateQueryString(this.mitIDQueryKeys.state, null, true);


            const response = await MitID.VerifyResponse(code, state, callbackUrl);
            if (!response.errors) {
                vm.customerHasHiddenInfo = response.name == "NAVNE & ADRESSEBESKYTTET";
                vm.customerMissesAddress = (!response.address || !response.postalCode || !response.city);

                if (vm.customerHasHiddenInfo) {
                    vm.customerInfo.Name = null;
                } else {
                    vm.customerInfo.Name = response.name;

                }
                vm.customerInfo.Address = response.address;
                vm.customerInfo.ZipCode = response.postalCode;
                vm.customerInfo.City = response.city;

                vm.customerInfo.MitIdCode = response.code;


                vm.mitIDCodeTimestamp = Math.round(Date.now() / 1000);

                if (response.isCompany) {
                    vm.customerInfo.IsCompany = response.isCompany;
                    vm.customerInfo.Cvr = response.cvr;
                    vm.customerInfo.CompanyName = response.companyName;
                }

                vm.toggleSpinner(false);


                nextTick(() => {
                    if (data.callback) {
                        data.callback();
                    }
                });

            } else if (response.errors) {
                const errorTitle = vm.dictionary.BookingFlowMitIdGeneralErrorTitle;

                vm.toggleSpinner(false);

                response.errors.forEach(error => {
                    var errorText = '';
                    switch (error) {
                        case 'mit-id-age':
                            errorText = vm.dictionary.BookingFlowMitIdVerificationAgeErrorText;
                            break;
                        case 'mit-id-invalid-person':
                            errorText = vm.dictionary.BookingFlowMitIdVerificationInvalidPersonErrorText;
                            break;
                        case 'mit-id-invalid-company':
                            errorText = vm.dictionary.BookingFlowMitIdVerificationInvalidCompanyErrorText;
                            break;
                        case 'mit-id-code':
                            errorText = vm.dictionary.BookingFlowMitIdAuthInitErrorText;
                            break;
                        case 'mit-id-invalid':
                            errorText = vm.dictionary.BookingFlowMitIdVerificationInvalidErrorText;
                            break;
                        default:
                            break;
                    }

                    vm.$toast.add({
                        severity: 'error', closable: false, summary: errorTitle, detail: errorText, life: 10000
                    });
                });
            }
        },
        getMitIDCallbackUrl(step, additionalQuery = '') {
            return `https://${window.location.hostname}/mitidhandler?redirectNodeId=${this.nodeId}&step=${step}${additionalQuery}`;
        }
    },
    computed: {

        sessionStorageKey() {
            return `booking${this.nodeId}`;
        }
    }
};
</script>
